export default __webpack_public_path__ + "static/media/1496.31510dad.png";